import { useModalManager } from '@library/model'
import type { FC } from 'react'

import css from './ModalContainer.css'

export const ModalContainer: FC = () => {
  const { dispatcher, other, movingModals } = useModalManager()

  return (
    <>
      <div ref={other} className={css.modalLayer} />
      <div ref={movingModals} className={css.modalLayer} />
      <div ref={dispatcher} className={css.modalLayer} />
    </>
  )
}
